import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { Snowplow2StatsSchemaLeadClickInterface } from '../schema/lead-click.interface';
import { StatsContextInterface } from '../../../stats/context.interface';

export class Snowplow2StatsAdapterSchemaLeadClick implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaLeadClickInterface {
    if (!this.context.local.lead) {
      throw new Error('Stats context "lead" is not set.');
    }

    const lead = this.context.local.lead;

    return {
      schema: 'iglu:ae.propertyfinder/lead_click/jsonschema/1-0-0',
      data: {
        medium: lead.medium,
      },
    };
  }
}
